import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSignature = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.726 7.456c.731-1.21-.277-2.05-1.21-2.616-.935-.565-2.147-1.068-2.88.142l-6.403 11.05a1.61 1.61 0 0 0-.185 1.226l.525 2.097c.072.286.36.46.648.391l2.1-.507a1.61 1.61 0 0 0 1-.733zM12.615 13.804l1.89-3.262c.433-.714-.162-1.21-.714-1.544l-.62-.38M10.478 8.411 8.344 7.18M9.648 19.548c.65.02 1.251-.365 1.536-.983l.172-.323c.488-1.057 2.042-.726 2.523.332.532 1.172 2.16 1.01 2.482-.249l.688-3.524c.211-.824 1.296-.882 1.58-.086l.982 2.758c.277.778.724 1.492 1.389 1.66"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSignature);
export default ForwardRef;
